import * as ActionTypes from '../actions/types';
import xs from 'xstream';
import GENERAL_FUNCTIONS from '../utils/functions/functions';
import * as actions from '../actions';
import delay from 'xstream/extra/delay';
import sampleCombine from 'xstream/extra/sampleCombine';
import HEADER_FUNCTIONS from '../utils/functions/headers';

const REQUEST_SURVEY_TYPE = 'requestSurveyType';
const POST_SURVEY_ANSWERS = 'postSurveyAnswers';
const FETCH_SURVEY_TYPES_AFTER_SUCCESS_POST =
    'fetchSurveyTypesAfterSuccessPost';
const FETCH_SURVEY_QUESTIONS = 'fetchSurveyQuestions';

export function requestSurveyType(sources) {
    const state$ = sources.STATE;
    const token$ = state$.map(state => state.applicationUser.accessToken);

    const request$ = sources.ACTION.filter(action => {
        return action.type === ActionTypes.FETCH_SURVEY_TYPE;
    })
        .compose(delay())
        .compose(sampleCombine(token$))
        .map(([action, token]) => ({
            url:
                GENERAL_FUNCTIONS.getBaseURL() +
                `api/ClaimApplicationSurvey/ClaimApplication/${action.payload.claimApplicationId}`,
            headers: HEADER_FUNCTIONS.headersWithTokenJson(token),
            category: REQUEST_SURVEY_TYPE,
            method: 'GET',
            send: action.payload,
        }));

    let httpResponse$ = sources.HTTP.select(REQUEST_SURVEY_TYPE)
        .map(response => response.replaceError(err => xs.of(err)))
        .flatten()
        .map(response =>
            response.status === 200
                ? actions.fetchSurveyTypeSuccess(response)
                : actions.fetchSurveyTypeFailed(response),
        );

    return {
        ACTION: httpResponse$,
        HTTP: request$,
    };
}

export function postSurveyAnswers(sources) {
    const state$ = sources.STATE;
    const token$ = state$.map(state => state.applicationUser.accessToken);

    const request$ = sources.ACTION.filter(
        action => action.type === ActionTypes.POST_SURVEY_ANSWERS,
    )
        .compose(delay())
        .compose(sampleCombine(token$))
        .map(([action, token]) => ({
            url:
                GENERAL_FUNCTIONS.getBaseURL() +
                `api/ClaimApplicationSurvey/ClaimApplication/${action.payload.data.claimApplicationId}/SurveyType/${action.payload.data.surveyTypeGroupCode}`,
            category: POST_SURVEY_ANSWERS,
            headers: HEADER_FUNCTIONS.headersWithTokenJson(token),
            method: 'POST',
            send: action.payload.data,
        }));

    let httpResponse$ = sources.HTTP.select(POST_SURVEY_ANSWERS)
        .map(response => response.replaceError(err => xs.of(err)))
        .flatten()
        .map(response =>
            response.status === 200
                ? actions.postSurveyAnswersSuccess(response)
                : actions.postSurveyAnswersFailed(response),
        );

    return {
        ACTION: httpResponse$,
        HTTP: request$,
    };
}

export function fetchSurveyQuestions(sources) {
    const action$ = sources.ACTION.filter(
        action =>
            action.type === ActionTypes.FETCH_SURVEY_TYPE_SUCCESS &&
            action?.payload?.body?.data?.length === 1,
    ).map(action => {
        let guid = GENERAL_FUNCTIONS.matchClaimIdFromUrl();
        return actions.fetchQuestionsByGroup({
            claimApplicationId: guid,
            groupCode: action?.payload?.body?.data[0]?.surveyTypeGroupCode,
        });
    });
    return {
        ACTION: action$,
    };
}
export function fetchSurveyTypesAfterSuccessPost(sources) {
    const action$ = sources.ACTION.filter(
        action => action.type === ActionTypes.POST_SURVEY_ANSWERS_SUCCESS,
    ).map(action => {
        let guid = GENERAL_FUNCTIONS.matchClaimIdFromUrl();
        return actions.fetchSurveyType({
            claimApplicationId: guid,
        });
    });
    return {
        ACTION: action$,
    };
}

//Maybe we will need it later!!!

// export function refetchSurveyType (sources) {
//     const action$ = sources.ACTION
//         .filter (action =>
//             action.type === ActionTypes.FETCH_SURVEY_TYPE_FAILED)
//         .map (action => {
//             let guid = GENERAL_FUNCTIONS.matchClaimIdFromUrl ();
//             return actions.fetchClaimApplicationById (guid);
//         });
//     return {
//         ACTION: action$,
//     };
// }
